<template>
   <v-container fluid class='mx-0 px-0'>
		<v-layout>
			<v-flex xs12 sm5 md3>
				<v-select :items="data" item-text="name" item-value="id" v-model="selected" label="Select a Station"  :color="cr.colorName">
				</v-select>
        <v-btn small v-on:click.native="showData" slot="activator" :color="cr.colorName" class="white--text ml-0">Show</v-btn>
			</v-flex> 
		</v-layout>
		<v-layout wrap>
			 <v-flex>
          <template v-if="showBtn">
            <v-btn @click.stop="infoToAdd(data)" class="ml-0">Add Display <v-icon class="pl-1" :color="cr.colorName">add_circle</v-icon></v-btn>        
          </template>
      	</v-flex>
		</v-layout>
		<v-dialog v-model="openFormAddDisplay" fullscreen transition="dialog-bottom-transition" :overlay="true" >
        <v-card>
         <v-toolbar style="flex: 0 0 auto;" :color="cr.colorName" class="white--text">
            <v-btn icon @click.native="openFormAddDisplay = false" dark>
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Form</v-toolbar-title>
            <v-spacer></v-spacer> 
          </v-toolbar>
          <formAddDisplay :openAddForm="openFormAddDisplay" :addInfo="info" :railId="railId" :cr="cr" ></formAddDisplay>
        </v-card>   
    </v-dialog>
    <v-dialog v-model="openDialog" max-width="500px">
        <v-card>
          <v-card-title class="error white--text">
            <v-icon class="white--text pr-3">warning</v-icon><span>Error</span>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
          <p>{{errorMsg}}</p>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" flat @click.stop="openDialog=false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
	</v-container>
	
</template>
<script>
import addDisplay from '../Forms/AddDisplay'
import {bus} from '../../main'
import {mapGetters} from 'vuex'
export default {
  props: {
    data: {
      type: Array
    },
    railId: {
      type: String
    },
    showBtn: {
      type: Boolean
    },
    cr: {
      type: Object
    }
  },
  components: {
    formAddDisplay: addDisplay
  },
  computed: {
    binding () {
      const binding = {}
      if (this.$vuetify.breakpoint.xsOnly || this.$vuetify.breakpoint.smOnly || this.$vuetify.breakpoint.mdOnly) binding.column = true
      return binding
    },
    ...mapGetters({
      showDisplay: 'showDisplay'
    })
  },
  data () {
    return {
      selected: '',
      items: this.data,
      openFormAddDisplay: false,
      openDialog: false,
      info: {},
      copySel: '',
      rname: '',
      imageUrl: '',
      showAddDisplayBtn: false,
      graphics: '',
      errorMsg: 'Please select a station'
    }
  },
  created () {
    var vm = this
    bus.$on('closeFormDisplayAdd', (data) => {
      vm.openFormAddDisplay = data
    })
  },
  methods: {
    showData (selected) {
      var vm = this
      if (vm.selected !== '') {
        vm.copySel = vm.selected
        vm.$emit('selectedItem', vm.copySel)
        vm.toggleBtn()
        vm.selected = ''
      } else {
        vm.openDialog = true
      }
    },
    toggleBtn () {
      this.$emit('toggleBtn', true)
    },
    infoToAdd (dat) {
      var vm = this
      this.openFormAddDisplay = true
      dat.forEach(function (d) {
        if (d.id === vm.copySel) {
          vm.info = d
        }
      })
    }
  }
}
</script>
<style scoped>
.custom-style{
  padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/displays/DisplaySelector.vue